import OrderDetailedModal from './OrderDetailedModal';

export default OrderDetailedModal;
